// editMeetingInTrip — pure builder that replaces a meeting in the edited trip.
//
// Extracted verbatim from `EditTripModal.js` (the body of `handleEditMeeting`
// that maps `editedTrip.meetings`, replacing the entry whose `id` matches
// `updatedMeeting.id`, and returns `{ ...prev, meetings: updatedMeetings }`) as
// part of the behavior-preserving refactor (issue #240). Non-matching meetings
// are preserved by reference; the matching one is swapped for `updatedMeeting`.
//
// Totality preserved exactly: the source read `editedTrip.meetings` directly
// (guaranteed an array by `initializeEditedTrip`) and matched on `meeting.id`;
// this builder mirrors that with no added guard. The async wrapper and the
// `setEditingMeeting(null)` side effect stay in the hook/container.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Returns the next edited trip with the matching meeting replaced.
 *
 * @param {Object} editedTrip - The current edited-trip working copy.
 * @param {Object} updatedMeeting - The replacement meeting (matched by `id`).
 * @returns {Object} The next edited-trip object.
 */
export function editMeetingInTrip(editedTrip, updatedMeeting) {
  const updatedMeetings = editedTrip.meetings.map(meeting =>
    meeting.id === updatedMeeting.id ? updatedMeeting : meeting
  );
  return {
    ...editedTrip,
    meetings: updatedMeetings
  };
}

export default editMeetingInTrip;
